export default "__VITE_ASSET__OrW4mwf4__"